import Constants from "@/mixins/constants.js";

export default {
  name: "Sorts",

  mixins: [Constants],

  data() {
    return {
      /**
       * sorts the hallArr by Title
       * @param {*} hallArr array of halls that should be sorted
       * @param {*} sortDesc whether to sort ascending (false) or descending (true)
       * @returns sorted hallArr
       */
      hallTitleSort: (hallArr, sortDesc) => {
        return hallArr.sort((hallA, hallB) => {
          var returnVal = this.SORT_NOTHING;

          // make sure title gets interpreted as string
          // ignore upper/lowercase
          var hallATitle = String(hallA.Title).toLowerCase();
          var hallBTitle = String(hallB.Title).toLowerCase();

          if (hallATitle > hallBTitle) {
            returnVal = this.SORT_A_BEFORE_B;
          } else if (hallATitle < hallBTitle) {
            returnVal = this.SORT_B_BEFORE_A;
          }

          if (sortDesc) returnVal *= -1;

          return returnVal;
        });
      },

      /**
       * sorts the hallArr by size of Area
       * @param {*} hallArr array of halls that should be sorted
       * @param {*} sortDesc whether to sort ascending (false) or descending (true)
       * @returns sorted hallArr
       */
      hallAreaSort: (hallArr, sortDesc) => {
        return hallArr.sort((hallA, hallB) => {
          var returnVal = this.SORT_NOTHING;

          var hallAArea = hallA.TypesOfUse.length;
          var hallBArea = hallB.TypesOfUse.length;

          if (hallAArea > hallBArea) {
            returnVal = this.SORT_A_BEFORE_B;
          } else if (hallAArea < hallBArea) {
            returnVal = this.SORT_B_BEFORE_A;
          }

          if (sortDesc) returnVal *= -1;

          return returnVal;
        });
      },

      /**
       * sorts the hallArr by the amount TypesOfUse
       * @param {*} hallArr array of halls that should be sorted
       * @param {*} sortDesc whether to sort ascending (false) or descending (true)
       * @returns sorted hallArr
       */
      hallTOUSort: (hallArr, sortDesc) => {
        return hallArr.sort((hallA, hallB) => {
          var returnVal = this.SORT_NOTHING;

          var hallAAmount = hallA.TypesOfUse.length;
          var hallBAmount = hallB.TypesOfUse.length;

          if (hallAAmount > hallBAmount) {
            returnVal = this.SORT_A_BEFORE_B;
          } else if (hallAAmount < hallBAmount) {
            returnVal = this.SORT_B_BEFORE_A;
          }

          if (sortDesc) returnVal *= -1;

          return returnVal;
        });
      },

      /**
       * sorts the hallArr by the amount of rent
       * @param {*} hallArr array of halls that should be sorted
       * @param {*} sortDesc whether to sort ascending (false) or descending (true)
       * @returns sorted hallArr
       */
      hallRentSort: (hallArr, sortDesc) => {
        return hallArr.sort((hallA, hallB) => {
          var returnVal = this.SORT_NOTHING;

          var hallARent = hallA.details.Rent.Amount;
          var hallBRent = hallB.details.Rent.Amount;

          if (hallARent > hallBRent) {
            returnVal = this.SORT_A_BEFORE_B;
          } else if (hallARent < hallBRent) {
            returnVal = this.SORT_B_BEFORE_A;
          }

          if (sortDesc) returnVal *= -1;

          return returnVal;
        });
      },
      /**
       * sorts the hallArr by the OpeningHours
       * @param {*} hallArr array of halls that should be sorted
       * @param {*} sortDesc whether to sort ascending (false) or descending (true)
       * @returns sorted hallArr
       */
      hallOpeningHoursSort: (hallArr, sortDesc) => {
        return hallArr.sort((hallA, hallB) => {
          var returnVal = this.SORT_NOTHING;

          var hallAOpening = new Date(hallA.details.OpeningHours[new Date().getDay()].From);
          var hallAClosing = new Date(hallA.details.OpeningHours[new Date().getDay()].To);
          var hallBOpening = new Date(hallB.details.OpeningHours[new Date().getDay()].From);
          var hallBClosing = new Date(hallB.details.OpeningHours[new Date().getDay()].To);

          var hallAOpeningHours = Math.abs(hallAClosing - hallAOpening);
          var hallBOpeningHours = Math.abs(hallBClosing - hallBOpening);

          if (hallAOpeningHours > hallBOpeningHours) {
            returnVal = this.SORT_A_BEFORE_B;
          } else if (hallAOpeningHours < hallBOpeningHours) {
            returnVal = this.SORT_B_BEFORE_A;
          }

          if (sortDesc) returnVal *= -1;

          return returnVal;
        });
      },
      /**
       * sorts the hallArr by the OpeningHours
       * @param {*} hallArr array of halls that should be sorted
       * @param {*} sortDesc whether to sort ascending (false) or descending (true)
       * @returns sorted hallArr
       */
      hallMinBookDurSort: (hallArr, sortDesc) => {
        return hallArr.sort((hallA, hallB) => {
          var returnVal = this.SORT_NOTHING;

          var hallAMinBookingDur = hallA.details.MinimalBookingDuration;
          var hallBMinBookingDur = hallB.details.MinimalBookingDuration;

          if (hallAMinBookingDur > hallBMinBookingDur) {
            returnVal = this.SORT_A_BEFORE_B;
          } else if (hallAMinBookingDur < hallBMinBookingDur) {
            returnVal = this.SORT_B_BEFORE_A;
          }

          if (returnVal !== this.SORT_NOTHING && sortDesc) returnVal *= -1;

          return returnVal;
        });
      },
    };
  },

  methods: {
    /** returns an array with available sorts for courses */
    getCourseSorts() {
      var courseSorts = [];

      courseSorts.push({key: this.SORT_COURSE_TITLE, displayName: this.$t("sort.name")});
      courseSorts.push({key: this.SORT_COURSE_STARTDATE, displayName: this.$t("sort.startDate")});
      courseSorts.push({key: this.SORT_COURSE_ENDDATE, displayName: this.$t("sort.endDate")});
      courseSorts.push({key: this.SORT_COURSE_MEMBERS, displayName: this.$t("sort.memberNumber")});
      courseSorts.push({key: this.SORT_COURSE_PRICE, displayName: this.$t("sort.price")});

      return courseSorts;
    },

    /** returns an array with available filters for courses */
    getCourseFilters() {
      var courseFilters = [];

      courseFilters.push({key: this.FILTER_COURSE_CANRESERVATE, displayName: this.$t("filters.reservable")});
      courseFilters.push({key: this.FILTER_COURSE_CLUBINTERNAL, displayName: this.$t("filters.clubIntern")});
      courseFilters.push({key: this.FILTER_COURSE_BOOKED, displayName: this.$t("filters.booked")});
      courseFilters.push({key: this.FILTER_COURSE_RESERVED, displayName: this.$t("filters.reserved")});

      return courseFilters;
    },

    /** returns an array with available sorts for halls */
    getHallSorts() {
      var hallSorts = [];

      hallSorts.push({key: this.SORT_HALL_TITLE, displayName: this.$t("sort.name")});
      hallSorts.push({key: this.SORT_HALL_AREA, displayName: this.$t("sort.area")});
      hallSorts.push({key: this.SORT_HALL_TOU, displayName: this.$t("sort.typesOfUse")});
      // hallSorts.push({key: this.SORT_HALL_RENT, displayName: this.$t("sort.rent")});
      // hallSorts.push({key: this.SORT_HALL_OPENINGHOURS, displayName: this.$t("sort.openingHours")});
      // hallSorts.push({key: this.SORT_HALL_MINBOOKDUR, displayName: this.$t("sort.bookingDuration")});

      return hallSorts;
    },

    /** returns an array with available filters for halls */
    getHallFilters() {
      var hallFilters = [];

      hallFilters.push({key: this.FILTER_HALL_CANBOOK, displayName: this.$t("filters.bookable")});
      hallFilters.push({key: this.FILTER_HALL_BOOKED, displayName: this.$t("filters.booked")});

      return hallFilters;
    },
  },
};
